export default __webpack_public_path__ + "static/media/interior.140d466e.jpg";